/* @flow weak */

export const APP_OFFLINE = "APP_OFFLINE";
export const APP_ONLINE = "APP_ONLINE";
export const APP_SET_LOCATION = "APP_SET_LOCATION";
export const APP_SHOW_MENU = "APP_SHOW_MENU";
export const APP_START = "APP_START";

export const APP_ERROR = "APP_ERROR";

export const INCREASE_LOADING = "INCREASE_LOADING";
export const DECREASE_LOADING = "DECREASE_LOADING";

export const TRANSITION_BLOCK = "TRANSITION_BLOCK";

export const CONFIRM_TRANSITION = "CONFIRM_TRANSITION";
export const REJECT_TRANSITION = "REJECT_TRANSITION";

export const setLocation = location => {
  if (typeof ga !== typeof undefined) {
    window.ga("send", "pageview", {
      page: location.pathname + location.search
    });
  }

  return {
    type: APP_SET_LOCATION,
    payload: { location }
  };
};

export const showMenu = (show: boolean) => ({
  type: APP_SHOW_MENU,
  payload: { show }
});

export const start = () => {
  return ({ dispatch }) => {
    return {
      type: APP_START
    };
  };
};

export const increaseLoading = () => ({
  type: INCREASE_LOADING
});

export const decreaseLoading = () => ({
  type: DECREASE_LOADING
});

export const confirmTransition = () => ({
  type: CONFIRM_TRANSITION
});

export const rejectTransition = () => {
  return {
    type: REJECT_TRANSITION
  };
};



/** WEBPACK FOOTER **
 ** ./src/common/app/actions.js
 **/